import { render, staticRenderFns } from "./DetailsPage_data.vue?vue&type=template&id=54811f8a&scoped=true&"
import script from "./DetailsPage_data.vue?vue&type=script&lang=js&"
export * from "./DetailsPage_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54811f8a",
  null
  
)

export default component.exports